import { createAction, props } from '@ngrx/store';
import { Modulo, ModuloForm } from '@models/.'
import { ResponseBadRequest } from '@interfaces/.';

export const MODULE_FIND = createAction('[Module] Find', props<{ id: string }>());
export const MODULE_FIND_ALL = createAction('[Module] Find All');

export const MODULE_FIND_SUCCESS = createAction('[Module] Find Success', props<{ module: Modulo }>());
export const MODULE_FIND_ALL_SUCCESS = createAction('[Module] Find All Success', props<{ moduleList: Modulo[] }>());
export const MODULE_CREATED_SUCCESS = createAction('[Module] Create Success', props<{ module: Modulo|null }>());

export const MODULE_FAILURE = createAction('[Module] Failure', props<{ error: ResponseBadRequest }>());

export const MODULE_UPDATE_LOADING = createAction('[Module] Update Loading', props<{ loading: boolean }>());
export const MODULE_UPDATE_FORM = createAction('[Module] Update Form', props<{ moduleForm: ModuloForm }>());
export const MODULE_UPDATE_SELECTED = createAction('[Module] Update Selected', props<{ moduleSelected: string[] }>());
export const MODULE_EDIT_MODE = createAction('[Module] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const MODULE_UPDATE_ID = createAction('[Module] Update Id', props<{ moduleId: string|null }>());

export const MODULE_CREATE_VIEW = createAction('[Module] Create View');
export const MODULE_UPDATE_VIEW = createAction('[Module] Update View', props<{ moduleId: string }>());

export const MODULE_CREATE = createAction('[Module] Create');
export const MODULE_UPDATE = createAction('[Module] Update');
export const MODULE_REMOVE = createAction('[Module] Remove', props<{ id: string }>());

export const MODULE_CREATE_COMPLETED = createAction('[Module] Create Completed');
export const MODULE_UPDATE_COMPLETED = createAction('[Module] Update Completed');
export const MODULE_REMOVE_COMPLETED = createAction('[Module] Remove Completed');

export const MODULE_RESET = createAction('[Module] Reset');
export const MODULE_RESET_FORM = createAction('[Module] Reset Form');
export const MODULE_RESET_ERROR = createAction('[Module] Reset Error');
export const MODULE_CLEAR_STATE = createAction('[Module] Clear State');